import { Component, OnDestroy, OnInit } from '@angular/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { LiveService } from '../../services/lives/lives.service';
import { ILive } from '../../interfaces/lives.interface';
import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../../interfaces/app-state.interface';
import { TrackingActions } from '../../state-management/tracking/tracking.action';
import { ActionEventsEnum } from '../../enum/tracking/action-events.enum';
import { Router } from '@angular/router';

@AutoUnsubscribe()
@Component({
  selector: 'live-popup',
  templateUrl: './live-popup.component.html',
  styleUrls: ['./live-popup.component.scss']
})
export class LivePopupComponent implements OnInit, OnDestroy {
  public liveNow: ILive[];
  public show: boolean = false;
  public buttonText: string = 'Ver todas as Lives';

  constructor(
    private liveService: LiveService,
    private store: Store<AppState>,
    private router: Router
  ) {}

  public ngOnInit() {
    const closed = localStorage.getItem('livePopupClosed');
    if (
      closed &&
      new Date().getTime() <
        new Date(closed).getTime() + 5 * 24 * 60 * 60 * 1000 // Data que fechou popup mais 5 dias
    ) {
      this.show = false;
      return;
    }
    timer(0, 60000)
      .pipe(
        switchMap(() =>
          this.liveService.getLives(
            this.buildDaysOffset(-1),
            this.buildDaysOffset(1)
          )
        )
      )
      .subscribe(lives => {
        this.liveNow = lives.filter(l => l.is_live_now);
        if (this.liveNow.length) {
          this.show = true;
          this.trackingMixpanel(ActionEventsEnum.ELEMENT_LOADED, {
            'Product Area Origin': 'Home Trader',
            'Element': 'Popup Live ao Vivo',
            'Label': this.liveNow[0].title,
            'Time Responsavel': 'Sky',
            'specificProperties': {
              'Live Exclusiva': this.liveNow[0].is_trader_vip
            }
          });
        } else {
          this.show = false;
        }
      });
  }

  ngOnDestroy(): void {}

  private buildDaysOffset(days: number): string {
    const d = new Date();
    d.setDate(d.getDate() + days);
    return d.toISOString();
  }

  public handleClosePopup() {
    localStorage.setItem('livePopupClosed', new Date().toISOString());
    this.show = false;
  }

  public handleClick() {
    this.trackingMixpanel(ActionEventsEnum.ELEMENT_CLICKED, {
      'Product Area Origin': 'Home Trader',
      'Element': this.buttonText,
      'Label': this.liveNow[0].title,
      'Group': 'Popup Live ao Vivo',
      'Time Responsavel': 'Sky',
      'specificProperties': {
        'Live Exclusiva': this.liveNow[0].is_trader_vip
      }
    });
    this.router.navigateByUrl('plataformas/catalogo-de-lives');
  }

  private trackingMixpanel(event: string, breakdowns: any) {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: { type: event, events: breakdowns }
    });
  }
}
